export const VanityPageText = {
    employeesOrClaimants: {
        english: 'Employees or claimants',
        spanish: 'Empleados o solicitantes',
    },
    employeeDetails: {
        english: 'Your benefits are now accessed at ',
        spanish: 'Ahora puede acceder a sus beneficios en ',
    },
    pleaseSaveUrl: {
        english: 'Please save the URL for easy access.',
        spanish: 'Guarde este enlace para acceder fácilmente.',
    },
    goToLincoln: {
        english: 'Go to LincolnFinancial.com',
        spanish: 'Vaya a LincolnFinancial.com',
    },
    errorBannerMessage: {
        english: 'We are unable to find an active user with this information. Employees, your benefits are now accessed at ',
        spanish: 'No pudimos encontrar un usuario activo con esta información. Empleados, ahora puede acceder a sus beneficios en ',
    },
    errorBannerLinkText: {
        english: 'LincolnFinancial.com',
        spanish: 'LincolnFinancial.com',
    },
};
